export const selectCategoryDoc = state => state.firestore.ordered.categories;

export const selectCategoryList = state => selectCategoryDoc(state)?.at(0)?.data || [];

export const selectInventory = state => state.inventory;

export const selectKeywords = state => state.keywords;

export const selectVendorOrders = state => state.vendorOrders;  
